import React__default from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { withSentryHub } from '../services/sentry-service.js';

const SentryErrorBoundary = ({ children, FallbackComponent, onReset, }) => {
    const handleError = (error) => {
        // 1- Simple approach : capture error with no tag
        // ------------------------
        withSentryHub().captureException(error);
        // ------------------------
        // 2- Approach adding a tag
        // ------------------------
        // withSentryHub().captureException(error, {
        //   // If you need to send things specific to this error on top of the
        //   // error itself then use this captureContext
        //   captureContext: (scope) => scope.setTags({ type: 'errorBoundary' }),
        // });
        // ------------------------
    };
    return (React__default.createElement(ErrorBoundary, { FallbackComponent: FallbackComponent, onError: handleError, onReset: onReset }, children));
};

export { SentryErrorBoundary as default };
//# sourceMappingURL=SentryErrorBoundary.js.map
